<header class="dashboard-topbar">
  <div class="topbar-leading">
    <button type="button" class="topbar-menu-btn" (click)="toggleSidebar.emit()" title="Menu">
      <span nz-icon nzType="menu" nzTheme="outline"></span>
    </button>
  </div>

  <div class="topbar-search" *ngIf="showSearch">
    <span nz-icon nzType="search" nzTheme="outline" class="topbar-search__icon"></span>
    <input
      type="text"
      class="topbar-search__input"
      [placeholder]="'dashboard.searchPlaceholder' | translate"
      [ngModel]="searchKeyword"
      (ngModelChange)="onSearchInput($event)"
    />
  </div>

  <div class="topbar-actions">

    <a
      routerLink="/sso-diagram"
      class="topbar-sso-diagram-btn"
      title="Hiển thị sơ đồ hệ thống SSO">
      <i class="fas fa-sitemap"></i>
      <span class="topbar-sso-diagram-btn__text">Hiển thị sơ đồ hệ thống SSO</span>
    </a>

    <button
      type="button"
      class="topbar-action-btn topbar-action-btn--theme"
      [title]="'dashboard.themeSelect' | translate"
      (click)="openThemeModal.emit()">
      <span nz-icon nzType="bg-colors" nzTheme="outline"></span>
    </button>
    <div class="topbar-profile" [title]="profileTitle">
      <button
        type="button"
        class="topbar-avatar-btn"
        [attr.aria-expanded]="menuOpen"
        aria-haspopup="menu"
        (click)="toggleMenu($event)">
        <div class="topbar-avatar" aria-hidden="true">{{ userInitial }}</div>
        <div class="topbar-profile__info">
          <span class="topbar-profile__name">{{ displayName }}</span>
          <span class="topbar-profile__account" *ngIf="showLoginAccount">{{ loginName }}</span>
        </div>
        <span class="topbar-profile__caret" nz-icon nzType="down" nzTheme="outline"></span>
      </button>

      <div class="topbar-profile-menu" *ngIf="menuOpen" role="menu" (click)="$event.stopPropagation()">
        <button type="button" class="topbar-profile-menu__item" role="menuitem" (click)="goToProfile()">
          <span nz-icon nzType="user" nzTheme="outline"></span>
          {{ 'profile.title' | translate }}
        </button>
        <button type="button" class="topbar-profile-menu__item topbar-profile-menu__item--danger" role="menuitem" (click)="onLogout()">
          <span nz-icon nzType="logout" nzTheme="outline"></span>
          {{ 'sidebar.logout' | translate }}
        </button>
      </div>
    </div>
  </div>
</header>
